<template>
	<CDialog
		id="add-email-domain-dialog"
		:visible="visible"
		title="Add Email Domain"
		custom-class="dialog--narrow"
		@done="$emit('close')"
	>
		<!-- Regex checks for 1 or more alphanumeric domains/subdomains and an alphabetic top-level domain, separated by periods -->
		<ValidationObserver ref="observer">
			<CValidatedInput
				vid="add-domain-name"
				:value="domainName"
				name="Domain Name"
				label="Domain Name"
				type="text"
				:rules="{ required: true, regex: /^([A-z0-9-]+\.)+[A-z]+$/ }"
				class="cog-input"
				@input="val => {
					val = val.replace(/^(www\.)/i, '');
					domainName = val;
				}"
			/>
		</ValidationObserver>

		<template #footer>
			<button
				class="c-modal-button c-modal-button-cancel button--secondary"
				@click="$emit('close')"
			>
				Cancel
			</button>
			<button
				class="c-modal-button button--primary"
				:class="{'c-button-executing': executing}"
				@click="validateAndSubmit"
			>
				Save
			</button>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent, ref, watch } from 'vue';
	import { ValidationObserver } from 'vee-validate';
	import CValidatedInput from 'src/components/form-controls/ValidatedInput.vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';

	export default defineComponent({
		name: 'CAddEmailDomainDialog',
		components: {
			ValidationObserver,
			CValidatedInput,
			CDialog
		},
		props: {
			visible: { type: Boolean, default: false }
		},
		emit: ['submit', 'close'],
		setup(props) {
			const executing = ref(false);
			const domainName = ref('');

			watch(() => props.visible, () => {
				executing.value = false;
			});
			return {
				executing,
				domainName
			};
		},
		methods: {
			validateAndSubmit() {
				this.$refs.observer.validate().then((valid: boolean) => {
					if (valid) {
						this.executing = true;
						this.$emit('submit', this.domainName);
					}
				});
			}
		}
	});
</script>